module.exports = __webpack_public_path__ + "img/freespin3.17ed29a7.png";